export const AUTH = {
    NAME_SLICE: 'auth',
    LOGIN_THUNK: 'auth/loginUser',
    EXCHANGE_CODE: 'auth/exchangeCode',
    REFRESH_TOKEN: 'auth/refreshToken',
    CHANGE_PASSWORD: 'auth/changePassword'
};
export const ACCOUNT = {
    NAME_SLICE: 'account',
    GET_PAGING: 'account/get-paging',
    ADD_ACCOUNT: 'account/add-account',
    UPDATE_ACCOUNT_CONST: 'account/update-account',
    DELETE_ACCOUNT_CONST: 'account/delete-account',
    GET_BY_ID_ACCOUNT: 'account/get-item-by-id'
};

export const NEWSCRAWLER = {
    NAME_SLICE: 'newscrawler',
    GET_PAGING: 'newscrawler/get-paging',
    GET_ITEM: 'newscrawler/get-item'
};

export const SLIDE_IMAGE = {
    NAME_SLICE: 'slideImage',
    GET_PAGING: 'slideImage/get-paging',
    GET_ITEM: 'slideImage/get-item'
};
export const REPORT_POST_CONST = {
    NAME_SLICE: 'report-post',
    NAME_SLICE_SYNTHENTIC: 'report-post-synthentic',
    GET_PAGING: 'report-post/get-paging'
};
export const REPORT_ADVERTISING_ANALYSIS_CONST = {
    NAME_SLICE: 'report-advertising',
    GET_COUNT_ADVERTISING_ANALYSIS: 'report-advertising/count'
};
export const BANNER_CONST = {
    NAME_SLICE: 'banner',
    GET_PAGING: 'banner/get-paging',
    ADD: 'banner/add',
    UPDATE: 'banner/update',
    DELETE: 'banner/delete',
    GET_BY_ID: 'banner/get-item-by-id'
};
export const EMAILCONFIG = {
    NAME_SLICE: 'emailconfig',
    GET_PAGING: 'emailconfig/get-paging',
    GET_ITEM: 'emailconfig/get-item',
    ADD_EMAILCONFIG: 'emailconfig/add-emailconfig',
    EDIT_EMAILCONFIG: 'emailconfig/edit-emailconfig',
    DELETE_EMAILCONFIG: 'emailconfig/delete-emailconfig'
};

export const PARTNER = {
    NAME_SLICE: 'partner',
    GET_PAGING: 'partner/get-paging',
    GET_ITEM: 'partner/get-item',
    ADD_PARTNER: 'partner/add-partner',
    EDIT_PARTNER: 'partner/edit-partner',
    DELETE_PARTNER: 'partner/delete-partner'
};

export const POST = {
    NAME_SLICE: 'post',
    GET_PAGING: 'post/get-paging',
    GET_PAGING_REPORT_POST_CREATEBY: 'post/get-paing-report-createby',
    EXPORT_EXCEL_REPORT_POST_CREATEBY: 'post/export-excel-report-createby',
};

export const CATEGORY = {
    NAME_SLICE: 'category',
    GET_PAGING: 'category/get-paging',
    GET_ITEM: 'category/get-item',
    ADD_CATEGORY: 'category/add-category',
    EDIT_CATEGORY: 'category/edit-category',
    DELETE_CATEGORY: 'category/delete-category'
};
export const LOGIN_HISTORY_CONST = {
    NAME_SLICE: 'loginHistory',
    GET_PAGING: 'loginHistory/get-paging',
    GET_STATISTIC: 'loginHistory/get-statistic'
};

export const APIROLEMAPPING = {
    NAME_SLICE: 'apirolemapping',
    GET_PAGING: 'apirolemapping/get-paging',
};

export const MENUITEM = {
    NAME_SLICE: 'menuitem',
    GET_MENU: 'menuitem/get-menu',
};

export const BOPHAN = {
    NAME_SLICE: 'boPhan',
    GET_ALL: 'boPhan/get-all',
    GET_BY_ID: 'boPhan/get-by-id',
    CREATE: 'boPhan/create',
    UPDATE: 'boPhan/update',
    DELETE: 'boPhan/delete',
};

export const TEAM = {
    NAME_SLICE: 'team',
    GET_ALL: 'team/get-all',
    GET_BY_ID: 'team/get-by-id',
    CREATE: 'team/create',
    UPDATE: 'team/update',
    DELETE: 'team/delete',
};

export const NHANVIEN = {
    NAME_SLICE: 'nhanVien',
    GET_ALL: 'nhanVien/get-all',
    GET_BY_ID: 'nhanVien/get-by-id',
    CREATE: 'nhanVien/create',
    UPDATE: 'nhanVien/update',
    DELETE: 'nhanVien/delete',
    LOAD_AVAILABLE_NGUOIDUNG: 'nhanVien/load-available-nguoidung',
    SYNC_FROM_ACCOUNT: 'nhanVien/sync-from-account',
};

export const VAI_TRO_OPTIONS = [
  {
    value: 0,          
    key: 'thanhvien',
    label: 'Thành viên',
  },
  {
    value: 1,       
    key: 'nhomtruong',
    label: 'Nhóm trưởng',
  },
  {
    value: 2,         
    key: 'phutrachbophan',
    label: 'Phụ trách bộ phận',
  },
];

export const mapVaiTroLabel = (vaiTro) => {
  const byValue = VAI_TRO_OPTIONS.find((x) => x.value === vaiTro);
  if (byValue) return byValue.label;

  const byKey = VAI_TRO_OPTIONS.find((x) => x.key === vaiTro);
  if (byKey) return byKey.label;

  return vaiTro;
};

export const NGUOIDUNG = {
    NAME_SLICE: 'nguoiDung',
    GET_BY_ACCOUNT_ID: 'nguoiDung/by-account',
    GET_BY_ID: 'nguoiDung/get-by-id',
};

export const KHOA = {
    NAME_SLICE: 'khoa',
    GET_ALL: 'khoa/get-all',
    GET_PAGING: 'khoa/get-paging',
    GET_ITEM: 'khoa/get-item',
    ADD_KHOA: 'khoa/add-khoa',
    EDIT_KHOA: 'khoa/edit-khoa',
    DELETE_KHOA: 'khoa/delete-khoa',
    SYNC_KHOA: 'khoa/sync-khoa',
};

export const QUYTRINH = {
    NAME_SLICE: 'quyTrinh',
    GET_ALL: 'quyTrinh/get-all',
    GET_BY_ID: 'quyTrinh/get-by-id',
    CREATE: 'quyTrinh/create',
    UPDATE: 'quyTrinh/update',
    DELETE: 'quyTrinh/delete',
};

export const TRANG_THAI_DU_AN_OPTIONS = [
    {
        value: 0,
        key: 'dangthuchien',
        label: 'Đang thực hiện',
    },
    {
        value: 1,
        key: 'hoanthanh',
        label: 'Hoàn thành',
    },
];

export const mapTrangThaiDuAnLabel = (status) => {
    const byValue = TRANG_THAI_DU_AN_OPTIONS.find((x) => x.value === status);
    if (byValue) return byValue.label;
    const byKey = TRANG_THAI_DU_AN_OPTIONS.find((x) => x.key === status);
    if (byKey) return byKey.label;
    return status;
};

export const PROJECT = {
    NAME_SLICE: 'project',
    GET_ALL: 'project/get-all',
    GET_ALL_PAGING: 'project/get-all-paging',
    GET_BY_ID: 'project/get-by-id',
    CREATE: 'project/create',
    UPDATE: 'project/update',
    DELETE: 'project/delete',
    UPDATE_STATUS: 'project/update-status',
    ADD_FILE: 'project/add-file',
    DELETE_FILE: 'project/delete-file',
    GET_FILES_BY_PROJECT: 'project/get-files-by-project',
};

export const PROJECT_STEP = {
    NAME_SLICE: 'projectStep',
    GET_BY_PROJECT: 'projectStep/get-by-project',
    UPDATE: 'projectStep/update',
};

export const LINHVUC = {
    NAME_SLICE: 'linhvuc',
    GET_ALL: 'linhvuc/get-all',
    GET_ITEM: 'linhvuc/get-item',
    ADD_LINHVUC: 'linhvuc/add-linhvuc',
    EDIT_LINHVUC: 'linhvuc/edit-linhvuc',
    DELETE_LINHVUC: 'linhvuc/delete-linhvuc',
};

export const LOAIYEUCAU = {
    NAME_SLICE: 'loaiyeucau',
    GET_ALL: 'loaiyeucau/get-all',
    GET_ITEM: 'loaiyeucau/get-item',
    ADD_LOAIYEUCAU: 'loaiyeucau/add-loaiyeucau',
    EDIT_LOAIYEUCAU: 'loaiyeucau/edit-loaiyeucau',
    DELETE_LOAIYEUCAU: 'loaiyeucau/delete-loaiyeucau',
};

export const HOTRO = {
    NAME_SLICE: 'hoTro',
    GET_ALL: 'hoTro/get-all',               
    GET_BY_ID: 'hoTro/get-by-id',           
    CREATE_HOTRO: 'hoTro/create',           
    UPDATE_HOTRO: 'hoTro/update',           
    DELETE_HOTRO: 'hoTro/delete',           
    GET_ALL_PAGING: 'hoTro/get-all-paging', 
};

export const TRANG_THAI_HO_TRO_OPTIONS = [
    {
        value: 0,
        key: 'dangthuchien',
        label: 'Đang thực hiện',
    },
    {
        value: 1,
        key: 'hoanthanh',
        label: 'Hoàn thành',
    },
];

export const mapTrangThaiHoTroLabel = (trangThaiHoTro) => {
    const byValue = TRANG_THAI_HO_TRO_OPTIONS.find((x) => x.value === trangThaiHoTro);
    if (byValue) return byValue.label;

    const byKey = TRANG_THAI_HO_TRO_OPTIONS.find((x) => x.key === trangThaiHoTro);
    if (byKey) return byKey.label;

    return trangThaiHoTro;
};

export const YEUCAU = {
    NAME_SLICE: 'yeuCau',
    GET_ALL: 'yeuCau/get-all',
    GET_BY_ID: 'yeuCau/get-by-id',
    CREATE: 'yeuCau/create',
    UPDATE: 'yeuCau/update',
    DELETE: 'yeuCau/delete',
    GET_ALL_PAGING: 'yeuCau/get-all-paging',
    ADD_FILE: 'yeuCau/add-file',
    DELETE_FILE: 'yeuCau/delete-file',
    GET_FILES_BY_PROJECT: 'yeuCau/get-files-by-yeucau',
};

export const TRANG_THAI_YEU_CAU_OPTIONS = [
    {
        value: 0,
        key: 'chophanhoi',
        label: 'Chờ phản hồi',
    },
    {
        value: 1,
        key: 'dangthuchien',
        label: 'Đang thực hiện',    
    },
    {
        value: 2,
        key: 'dangtest',
        label: 'Đang test',
    },
    {
        value: 3,
        key: 'chonangcap',
        label: 'Chờ nâng cấp',
    },
    {
        value: 4,
        key: 'hoanthanh',
        label: 'Hoàn thành',
    },
];

export const mapTrangThaiYeuCauLabel = (trangThaiYeuCau) => {
    const byValue = TRANG_THAI_YEU_CAU_OPTIONS.find((x) => x.value === trangThaiYeuCau);
    if (byValue) return byValue.label;
    const byKey = TRANG_THAI_YEU_CAU_OPTIONS.find((x) => x.key === trangThaiYeuCau);
    if (byKey) return byKey.label;
    return trangThaiYeuCau;
};

export const MUC_DO_UU_TIEN = [
    {
        value: 0,
        key: 'ratgap',
        label: 'Rất gấp',
    },
    {
        value: 1,
        key: 'gap',
        label: 'Gấp',
    },
    {
        value: 2,
        key: 'binhthuong',
        label: 'Bình thường',
    },
];

export const mapMucDoUuTienLabel = (mucDoUuTien) => {
    const byValue = MUC_DO_UU_TIEN.find((x) => x.value === mucDoUuTien);
    if (byValue) return byValue.label;
    const byKey = MUC_DO_UU_TIEN.find((x) => x.key === mucDoUuTien);
    if (byKey) return byKey.label;
    return mucDoUuTien;
};

export const CONGVIEC = {
    NAME_SLICE: 'congViec',
    GET_BY_PROJECT_STEP: 'congViec/get-by-project-step',
    CREATE: 'congViec/create',
    UPDATE: 'congViec/update',
    DELETE: 'congViec/delete',
};

export const NHIEMVUKHAC = {
    NAME_SLICE: 'nhiemVuKhac',
    GET_ALL: 'nhiemVuKhac/get-all',
    GET_BY_ID: 'nhiemVuKhac/get-by-id',
    CREATE: 'nhiemVuKhac/create',
    UPDATE: 'nhiemVuKhac/update',
    DELETE: 'nhiemVuKhac/delete',
    GET_ALL_PAGING: 'nhiemVuKhac/get-all-paging',
    GET_FILES_BY_NHIEMVUKHAC: 'nhiemVuKhac/get-files-by-nhiemvukhac',
    ADD_FILE: 'nhiemVuKhac/add-file',
    DELETE_FILE: 'nhiemVuKhac/delete-file',
};

export const TRANG_THAI_KHAC_OPTIONS = [
    {
        value: 0,
        key: 'chuabatdau',
        label: 'Chưa bắt đầu',
    },
    {
        value: 1,
        key: 'dangthuchien',
        label: 'Đang thực hiện',
    },
    {
        value: 2,
        key: 'hoanthanh',
        label: 'Hoàn thành',
    },
];

export const mapTrangThaiKhacLabel = (trangThaiKhac) => {
    const byValue = TRANG_THAI_KHAC_OPTIONS.find((x) => x.value === trangThaiKhac);
    if (byValue) return byValue.label;
    const byKey = TRANG_THAI_KHAC_OPTIONS.find((x) => x.key === trangThaiKhac);
    if (byKey) return byKey.label;
    return trangThaiKhac;
};

export const CONGVIECKHAC = {
    NAME_SLICE: 'congViecKhac',
    GET_BY_ID: 'congViecKhac/get-by-id',
    CREATE: 'congViecKhac/create',
    UPDATE: 'congViecKhac/update',
    DELETE: 'congViecKhac/delete',
    GET_BY_NHIEM_VU: 'congViecKhac/get-by-nhiem-vu',
};

export const TASK_ASSIGNMENT = {
    NAME_SLICE: 'taskAssignment',
    GET_ALL: 'taskAssignment/get-all',
    CREATE: 'taskAssignment/create',
    UPDATE: 'taskAssignment/update',
    DELETE: 'taskAssignment/delete',
};

export const TRANG_THAI_CONG_VIEC_OPTIONS = [
    {
        value: 0,
        key: 'canlam',
        label: 'Cần làm',
    },
    {
        value: 1,
        key: 'danglam',
        label: 'Đang làm',
    },
    {
        value: 2,
        key: 'choduyet',
        label: 'Chờ duyệt',
    },
    {
        value: 3,
        key: 'hoanthanh',
        label: 'Hoàn thành',
    },
];

export const mapTrangThaiCongViecLabel = (trangThai) => {
    const byValue = TRANG_THAI_CONG_VIEC_OPTIONS.find(
        (x) => x.value === trangThai
    );
    if (byValue) return byValue.label;

    const byKey = TRANG_THAI_CONG_VIEC_OPTIONS.find(
        (x) => x.key === trangThai
    );
    if (byKey) return byKey.label;

    return trangThai;
};

export const TRANG_THAI_QUY_TRINH_OPTIONS = [
    {
        value: 0,
        key: 'chuabatdau',
        label: 'Chưa bắt đầu',
    },
    {
        value: 1,
        key: 'dangthuchien',
        label: 'Đang thực hiện',
    },
    {
        value: 2,
        key: 'hoanthanh',
        label: 'Hoàn thành',
    },
];

export const mapTrangThaiQuyTrinhLabel = (status) => {
    const byValue = TRANG_THAI_QUY_TRINH_OPTIONS.find((x) => x.value === status);
    if (byValue) return byValue.label;
    const byKey = TRANG_THAI_QUY_TRINH_OPTIONS.find((x) => x.key === status);
    if (byKey) return byKey.label;
    return status;
};

export const TRANG_THAI_CONG_VIEC_KHAC_OPTIONS = [
    {
        value: 0,
        key: 'chuabatdau',
        label: 'Chưa bắt đầu',
    },
    {
        value: 1,
        key: 'dangthuchien',
        label: 'Đang thực hiện',
    },
    {
        value: 2,
        key: 'choduyet',
        label: 'Chờ duyệt',
    },
    {
        value: 3,
        key: 'hoanthanh',
        label: 'Hoàn thành',
    },
];

export const mapTrangThaiCongViecKhacLabel = (status) => {
    const byValue = TRANG_THAI_CONG_VIEC_KHAC_OPTIONS.find((x) => x.value === status);
    if (byValue) return byValue.label;
    const byKey = TRANG_THAI_CONG_VIEC_KHAC_OPTIONS.find((x) => x.key === status);
    if (byKey) return byKey.label;
    return status;
};

export const THONGKE = {
    NAME_SLICE: 'thongKe',
    HOTRO: 'thongKe/get-hotro-breakdown',
    HOTRO_SUMMARY: 'thongKe/get-hotro-summary',
    YEUCAU: 'thongKe/get-yeucau-breakdown',
    YEUCAU_SUMMARY: 'thongKe/get-yeucau-summary',
};

export const NHIEMVUCANHAN = {
    NAME_SLICE: 'nhiemVuCaNhan',
    DEBUG_CURRENT_USER: 'nhiemVuCaNhan/debug-current-user',
    GET_PROJECT_TASKS: 'nhiemVuCaNhan/get-project-tasks',
    GET_OTHER_TASKS: 'nhiemVuCaNhan/get-other-tasks',
    GET_YEU_CAU_TASKS: 'nhiemVuCaNhan/get-yeu-cau-tasks',
    GET_HO_TRO_TASKS: 'nhiemVuCaNhan/get-ho-tro-tasks',
};

export const NGUOIPHOIHOP = {
    NAME_SLICE: 'nguoiPhoiHop',
    GET_ALL: 'nguoiPhoiHop/get-all',
    CREATE: 'nguoiPhoiHop/create',
    DELETE: 'nguoiPhoiHop/delete',
    GET_ALL_PAGING: 'nguoiPhoiHop/get-all-paging',
    GET_BY_ID: 'nguoiPhoiHop/get-by-id',
};

export const MUC_DO_PHUC_TAP_OPTIONS = [
    {
        value: 0,
        key: 'de',
        label: 'Dễ',
    },
    {
        value: 1,
        key: 'binhthuong',
        label: 'Bình thường',
    },
    {
        value: 2,
        key: 'kho',
        label: 'Khó',
    },
    {
        value: 3,
        key: 'ratkho',
        label: 'Rất khó',
    },
];

export const mapMucDoPhucTapLabel = (mucDoPhucTap) => {
    const byValue = MUC_DO_PHUC_TAP_OPTIONS.find((x) => x.value === mucDoPhucTap);
    if (byValue) return byValue.label;
    const byKey = MUC_DO_PHUC_TAP_OPTIONS.find((x) => x.key === mucDoPhucTap);
    if (byKey) return byKey.label;
    return mucDoPhucTap;
};

export const LOAI_LOI_OPTIONS = [
    {
        value: 0,
        key: 'loinguoidung',
        label: 'Lỗi người dùng',
    },
    {
        value: 1,
        key: 'loiphanmem',
        label: 'Lỗi phần mềm',
    },
    {
        value: 2,
        key: 'loimang',
        label: 'Lỗi mạng',
    },
    {
        value: 3,
        key: 'khac',
        label: 'Khác',
    },
];

export const mapLoaiLoiLabel = (loaiLoi) => {
    const byValue = LOAI_LOI_OPTIONS.find((x) => x.value === loaiLoi);
    if (byValue) return byValue.label;
    const byKey = LOAI_LOI_OPTIONS.find((x) => x.key === loaiLoi);
    if (byKey) return byKey.label;
    return loaiLoi;
};

export const BAOCAO_MODULE = {
  NAME_SLICE: 'baocao',
  GET_TONG_QUAN_TEAM: 'baocao/get-tong-quan-team',
  GET_THANH_VIEN_TEAM: 'baocao/get-thanh-vien-team',
  GET_CHI_TIET_NHAN_VIEN: 'baocao/get-chi-tiet-nhan-vien',
  GET_CHI_TIET_PHAT_TRIEN_PHAN_MEM: 'baocao/get-chi-tiet-phat-trien-phan-mem',
  GET_CHI_TIET_XU_LY_YEU_CAU: 'baocao/get-chi-tiet-xu-ly-yeu-cau',
  GET_CHI_TIET_XU_LY_YEU_CAU_THANH_VIEN: 'baocao/get-chi-tiet-xu-ly-yeu-cau-thanh-vien',
  GET_CHI_TIET_HO_TRO: 'baocao/get-chi-tiet-ho-tro',
  GET_CHI_TIET_HO_TRO_THANH_VIEN: 'baocao/get-chi-tiet-ho-tro-thanh-vien',
  GET_CHI_TIET_NHIEM_VU_KHAC: 'baocao/get-chi-tiet-nhiem-vu-khac',
  GET_CHI_TIET_NHIEM_VU_KHAC_THANH_VIEN: 'baocao/get-chi-tiet-nhiem-vu-khac-thanh-vien',
  GET_TONG_HOP_NHAN_VIEN: 'baocao/get-tong-hop-nhan-vien',
};

export const HOME_MODULE = {
  NAME_SLICE: 'home',
  GET_PHAT_TRIEN_PHAN_MEM: 'home/get-phat-trien-phan-mem',
  GET_XU_LY_YEU_CAU: 'home/get-xu-ly-yeu-cau',
  GET_HO_TRO: 'home/get-ho-tro',
  GET_NHIEM_VU_KHAC: 'home/get-nhiem-vu-khac',
};

